import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Observable } from 'rxjs';
import { Course } from '../models/course.model';
import { Order } from '../models/order.model';
import { Lesson } from '../models/lesson.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { Question } from '../models/question.model';
import { Bank } from '../models/bank.model';
import { Coupon } from '../models/coupon.model';


@Injectable({
  providedIn: 'root'
})
export class CourseService {

  constructor(
    private fns: AngularFireFunctions,
    private firestore: AngularFirestore
  ) {
  }

  findAll(limit: number): Promise<Course[]> {
    let promise: Promise<Course[]> = new Promise((resolve, reject) => {
      const query: Observable<any> = this.firestore.collection('courses', ref => ref.where('status', '==', 1).limit(limit)).get()
      query.subscribe(queriedItems => {
        var courses = queriedItems.docs.map(function (doc) {
          var course: Course = new Course()
          course.id = doc.id
          Object.assign(course, doc.data())
          course.mapping()
          return course
        })
        resolve(courses)
      })
    });
    return promise;
  }


  findAllWithPagination(limit: number, isNext: boolean, lastDoc?: firebase.firestore.QueryDocumentSnapshot): Promise<[Course[], firebase.firestore.QueryDocumentSnapshot, firebase.firestore.QueryDocumentSnapshot]> {
    let promise: Promise<[Course[], firebase.firestore.QueryDocumentSnapshot, firebase.firestore.QueryDocumentSnapshot]> = new Promise((resolve, reject) => {
      var query: Observable<any>
      if (lastDoc) {
        if (isNext) {
          query = this.firestore.collection('courses', ref => ref.where('status', '==', 1).startAfter(lastDoc).limit(limit)).get()
        } else {
          query = this.firestore.collection('courses', ref => ref.where('status', '==', 1).endBefore(lastDoc).limit(limit)).get()
        }

      } else {
        query = this.firestore.collection('courses', ref => ref.where('status', '==', 1).limit(limit)).get()
      }
      query.subscribe(queriedItems => {
        const lastDoc = queriedItems.docs[queriedItems.docs.length - 1]
        const preDoc = queriedItems.docs[0]
        var courses = queriedItems.docs.map(function (doc) {
          var course: Course = new Course()
          course.id = doc.id
          Object.assign(course, doc.data())
          course.mapping()
          return course;
        })
        resolve([courses, lastDoc, preDoc])
      })
    });
    return promise;
  }

  

  findAllActive(): Observable<[Course]> {
    const getCoursesCallable = this.fns.httpsCallable('getActiveCourses');
    return getCoursesCallable({});
  }

  findOne(id: string): Observable<Course> {
    const getCourseCallable = this.fns.httpsCallable('getCourse');
    return getCourseCallable({ id: id });
  }


  checkOutCourse(course: any, bank: any, tid: string,screenshot:string,coupon?:Coupon): Observable<any> {
    const submitPaymentCallable = this.fns.httpsCallable('submitPayment');
    return submitPaymentCallable({
      course: course,
      bank: bank,
      tid: tid,
      screenshot:screenshot,
      coupon:coupon
    });
  }

  checkCoupon(code:string): Observable<any> {
    const checkCouponCallable = this.fns.httpsCallable('checkCoupon');
    return checkCouponCallable({
      couponCode: code,
    });
  }

  updateViewCount(courseId:string): Observable<any> {
    const updateViewCountCallable = this.fns.httpsCallable('updateEnglishCourseViewCount');
    return updateViewCountCallable({
      id:courseId
    });
  }


  getMyPendingOrders(): Observable<[Order]> {
    const getMyPendingOrdersCallable = this.fns.httpsCallable('getMyPendingOrders');
    return getMyPendingOrdersCallable({});
  }

  getMyCourses(): Observable<[Course]> {
    const getMyCoursesCallable = this.fns.httpsCallable('getMyCourses');
    return getMyCoursesCallable({});
  }
  getLessons(courseId: string): Observable<[Lesson]> {
    const getLessonsCallable = this.fns.httpsCallable('getLessons');
    return getLessonsCallable({ courseId: courseId });
  }

  getPaymentMethods(): Observable<[Bank]> {
    const getPaymentMethodsCallable = this.fns.httpsCallable('getPaymentMethods');
    return getPaymentMethodsCallable({});
  }

  checkAvailableCourse(courseId: string): Promise<any> {

    let promise = new Promise((resolve, reject) => {
      let user = JSON.parse(localStorage.getItem('user'));
      this.firestore.collection('students').doc(user.uid).collection('courses').doc(courseId).get().subscribe(queriedItem => {
        if (queriedItem.data()) {
          var submittedQuizLesson:string[] = queriedItem.data().submittedQuizLesson
          if(!submittedQuizLesson){
            submittedQuizLesson = []
          }
          resolve({
            passCheck: true,
            watchedLessons: queriedItem.data().watchedLessons,
            submittedQuizLesson:submittedQuizLesson
          })
        } else {
          resolve({
            passCheck: false,
            watchedLessons: []
          })
        }
      })
    });
    return promise;
  }

  checkAllowBuyingCourse(courseId: string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      let user = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        resolve({
          allow: true
        })
      }
      this.firestore.collection('students').doc(user.uid).collection('courses').doc(courseId).get().subscribe(queriedItem => {
        if (queriedItem.data()) {
          resolve({
            allow: false
          })
        } else {
          resolve({
            allow: true
          })
        }
      })
    });
    return promise;
  }

  checkDuplicatebuyingCourse(courseId: string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      let user = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        resolve({
          allow: true
        })
      }
      this.firestore.collection('payment-transactions',ref => ref.where('uid','==',user.uid).where('course.id', '==',courseId )).get().subscribe(queriedItems => {
        resolve({
          duplicated: queriedItems.docs.length > 0
        })
      })
      
    });
    return promise;
  }



  addWatchedLesson(courseId: string, lessonId: string): Observable<any> {
    const addWatchedLessonCallable = this.fns.httpsCallable('addWatchedLesson');
    return addWatchedLessonCallable({ courseId: courseId, lessonId: lessonId });
  }

  addComment(courseId: string,lessonId:string, text: string) {
    const addCommentCallable = this.fns.httpsCallable('addComment');
    return addCommentCallable({ courseId: courseId,lessonId:lessonId, text: text });
  }

  addReplyComment(commentId: string, commentDesc: any) {
    const addReplyCommentCallable = this.fns.httpsCallable('addReplyComment');
    return addReplyCommentCallable({ commentId: commentId, commentDesc: commentDesc });
  }
  submitQuiz(lessonId:string,questions:Question[],courseId:string):Observable<any>{
    const submitQuizCallable = this.fns.httpsCallable('submitQuiz');
    return submitQuizCallable({ lessonId: lessonId,questions:questions,courseId:courseId});
  }





}
